import createCapexCancelWindow from "../shared/capex-cancel-window";

export default createCapexCancelWindow({
    baseUrl: '/Finance/CapExTechnologyRequest',
    windowSelector: '#CapExTechCancel',
});
